<div class="app-container mat-typography">
    <router-outlet></router-outlet>
</div>
